import { gql } from '@apollo/client';

// Get user by ID - Simplified to only fetch available fields
export const GET_USER_BY_ID = gql`
  query GetUserById($userId: uuid!) {
    user(where: { u_id: { _eq: $userId } }) {
      u_id
      u_first_name
      u_last_name
      u_full_name
      u_email_id
      u_phone_number
      u_country_code
      u_created_at
      u_last_online
      u_email_enabled
      u_payouts_voided
      u_void_reason
      u_void_date
      u_stripe_business_name
      tickets_sold_amount
      u_pricing_mode
      u_fee_percentage
      u_teams
      u_seller_tier
      u_hear_about_us
      u_sales_reps_id
      sales_reps {
        sr_commission_rate
        sr_first_name
        sr_last_name
      }
    }
  }
`;


export const GET_SUPER_USER_BY_USER_ID = gql`
  query GetSuperUserByUserId($userId: uuid!) {
    super_user(
      where: {
        u_id: { _eq: $userId }
        su_deleted_at: { _is_null: true }
        su_is_active: { _eq: true }
      }
      limit: 1
    ) {
      su_id
      percentage
      su_email_id
      su_first_name
      su_last_name
    }
  }
`;

export const UPDATE_SUPER_USER_PERCENTAGE = gql`
  mutation UpdateSuperUserPercentage($su_id: uuid!, $percentage: float8!) {
    update_super_user_by_pk(
      pk_columns: { su_id: $su_id }
      _set: { percentage: $percentage, su_is_active: true }
    ) {
      su_id
      percentage
    }
  }
`;

export const DEACTIVATE_SUPER_USER = gql`
  mutation DeactivateSuperUser($su_id: uuid!) {
    update_super_user_by_pk(
      pk_columns: { su_id: $su_id }
      _set: { su_is_active: false }
    ) {
      su_id
      su_is_active
    }
  }
`;

export const INSERT_SUPER_USER = gql`
  mutation InsertSuperUser(
    $u_id: uuid!
    $su_email_id: String!
    $su_first_name: String!
    $su_last_name: String!
    $percentage: float8!
  ) {
    insert_super_user_one(
      object: {
        u_id: $u_id
        su_email_id: $su_email_id
        su_first_name: $su_first_name
        su_last_name: $su_last_name
        su_is_active: true
        percentage: $percentage
      }
    ) {
      su_id
      percentage
    }
  }
`;

export const UPDATE_USER_EMAIL_STATUS = gql`
  mutation UpdateUserEmailStatus($userId: uuid!, $u_email_enabled: Boolean!) {
    update_user(
      where: { u_id: { _eq: $userId } }
      _set: { u_email_enabled: $u_email_enabled }
    ) {
      returning {
        u_id
        u_email_enabled
      }
    }
  }
`;

// Get user tickets - use existing filterlisttickets function filtered by user id
export const GET_USER_TICKETS = gql`
  query GetUserTickets($userId: uuid!) {
    tickets: filterlisttickets(
      args: {
        enddate: null
        leagueid: null
        startdate: null
        ticketid: null
        tpid: null
        array_tpid: null
        ticket_status: null
        payment_status: null
      }
      where: { _and: { u_id: { _eq: $userId } } }
      limit: 1000
      order_by: [
        { tp_updated_at: desc }
        { e_date: asc }
        { e_name: asc }
        { tp_section: asc }
        { tp_row: asc }
        { tp_seat_no: asc }
        { tp_id: asc }
      ]
    ) {
      tp_id
      t_id
      t_updated_at: tp_updated_at
      t_section: tp_section
      t_row: tp_row
      t_seat_no: tp_seat_no
      t_status: tp_status
      t_list_price: tp_list_price
      t_sold_price: tp_sold_amount
      t_sold_amount: tp_sold_amount
      t_payment_status: tp_payment_status
      t_payout_status: tp_payout_status
      t_event_date: e_date
      t_event_date_time_zone: e_date_time_zone
      e_name
      e_id
    }
    tickets_aggregate: filterlisttickets_aggregate(
      args: {
        enddate: null
        leagueid: null
        startdate: null
        ticketid: null
        tpid: null
        array_tpid: null
        ticket_status: null
        payment_status: null
      }
      where: { _and: { u_id: { _eq: $userId } } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_USER_TICKET_MARKETPLACES = gql`
  query GetUserTicketMarketplaces($userId: uuid!) {
    ticket_placement: getmanageticketwithvlids(
      where: { u_id: { _eq: $userId } }
      limit: 1000
      order_by: { tp_updated_at: desc }
    ) {
      tp_id
      tp_marketplace_name
      tp_status
      tp_quick_cut_amount
      tp_updated_at
    }
  }
`;

export const GET_USER_SAVED_SEAT_INFO = gql`
  query GetUserSavedSeatInfo($userId: uuid!, $lcId: uuid!) {
    user_saved_seat_info(
      where: { u_id: { _eq: $userId }, lc_id: { _eq: $lcId } }
      order_by: { updated_at: desc }
    ) {
      ussi_id
      u_id
      lc_id
      team_name
      section
      seat_row
      start_seat
      end_seat
      updated_at
    }
  }
`;

export const INSERT_USER_SAVED_SEAT_INFO = gql`
  mutation InsertUserSavedSeatInfo(
    $u_id: uuid!
    $lc_id: uuid!
    $team_name: String!
    $section: String!
    $seat_row: String!
    $start_seat: String!
    $end_seat: String!
  ) {
    insert_user_saved_seat_info_one(
      object: {
        u_id: $u_id
        lc_id: $lc_id
        team_name: $team_name
        section: $section
        seat_row: $seat_row
        start_seat: $start_seat
        end_seat: $end_seat
      }
    ) {
      ussi_id
    }
  }
`;

export const UPDATE_USER_SAVED_SEAT_INFO = gql`
  mutation UpdateUserSavedSeatInfo(
    $ussi_id: uuid!
    $section: String!
    $seat_row: String!
    $start_seat: String!
    $end_seat: String!
  ) {
    update_user_saved_seat_info_by_pk(
      pk_columns: { ussi_id: $ussi_id }
      _set: {
        section: $section
        seat_row: $seat_row
        start_seat: $start_seat
        end_seat: $end_seat
      }
    ) {
      ussi_id
    }
  }
`;

// Get user performance metrics - Fixed to handle uuid type
export const GET_USER_PERFORMANCE = gql`
  query GetUserPerformance($userId: uuid!) {
    user_performance(where: { up_user_id: { _eq: $userId } }) {
      up_active_count
      up_potential_revenue
      up_sold_count
      up_total_revenue
      up_paid_out
      up_fee_rate
      up_phone_verified
      up_verified_count
      up_listed_count
      up_delisted_count
      up_unsold_count
      up_never_transferred
    }
  }
`;

// Get user analytics - Fixed to handle uuid type


export const GET_USER_PREFERENCE_TEAMS = gql`
  query GetUserPreferenceTeams($userId: uuid!) {
    user_preference(where: { u_id: { _eq: $userId } }) {
      lc_id
    }
  }
`;

export const GET_LEAGUE_CATEGORIES_BY_IDS = gql`
  query GetLeagueCategoriesByIds($categoryIds: [uuid!]!) {
    league_categories(where: { lc_id: { _in: $categoryIds } }) {
      lc_id
      lc_abbrev
      lc_name
      lc_colour_code
      l_id
    }
  }
`;

// Update user
export const UPDATE_USER = gql`
  mutation UpdateUser($userId: uuid!, $input: user_set_input!) {
    update_user(
      where: { u_id: { _eq: $userId } }
      _set: $input
    ) {
      returning {
        u_id
        u_first_name
        u_last_name
        u_full_name
        u_email_id
        u_phone_number
        u_country_code
        u_stripe_business_name
        u_pricing_mode
     
       
      }
    }
  }
`;

// Delete user - Fixed to handle uuid type
export const DELETE_USER = gql`
  mutation DeleteUser($userId: uuid!) {
    delete_user(
      where: { u_id: { _eq: $userId } }
    ) {
      returning {
        u_id
      }
    }
  }
`;

// Add QA note
export const ADD_QA_NOTE = gql`
  mutation AddQANote($input: qa_notes_insert_input!) {
    insert_qa_notes_one(object: $input) {
      qn_id
      qn_content
      qn_created_at
    }
  }
`;

// Add VL note
export const ADD_VL_NOTE = gql`
  mutation AddVLNote($input: vl_notes_insert_input!) {
    insert_vl_notes_one(object: $input) {
      vn_id
      vn_content
      vn_type
      vn_created_at
    }
  }
`;
// Add to your existing UserdetailsQuery.ts

export const GET_USER_NOTES = gql`
  query GetUserNotes($userId: uuid!) {
    user_notes(where: { u_id: { _eq: $userId } }, order_by: { n_created_at: desc }) {
      n_id
      n_type
      n_content
      n_created_at
      n_created_by
      n_updated_at
    }
  }
`;

export const ADD_USER_NOTE = gql`
  mutation AddUserNote($userId: uuid!, $type: String!, $content: String!) {
    insert_user_notes_one(object: {
      u_id: $userId,
      n_type: $type,
      n_content: $content,
      n_created_by: "admin"
    }) {
      n_id
      n_type
      n_content
      n_created_at
      n_created_by
      n_updated_at
    }
  }
`;

export const UPDATE_USER_NOTE = gql`
  mutation UpdateUserNote($noteId: uuid!, $content: String!, $updatedAt: timestamptz!) {
    update_user_notes_by_pk(pk_columns: { n_id: $noteId }, _set: { n_content: $content, n_updated_at: $updatedAt }) {
      n_id
    }
  }
`;

export const DELETE_USER_NOTE = gql`
  mutation DeleteUserNote($noteId: uuid!) {
    delete_user_notes_by_pk(n_id: $noteId) {
      n_id
    }
  }
`;

// Append this to your existing queries/mutations
export const GET_USER_ANALYTICS = gql`
  query GetUserAnalytics($userId: String!) {
    user_analytics: user_analytics(where: { u_id: { _eq: $userId } }) {
      ua_seller_status
      ua_total_revenue_year
      ua_tickets_sold
      ua_avg_ticket_price
      ua_delist_rate
      ua_sell_through
      ua_paid_out
      ua_status_flags
      ua_marketplace_data  # Make sure this field exists
      ua_league_breakdown  # Make sure this field exists
      ua_timing_data       # Make sure this field exists
    }
  }
`;

// Add mutation to append a new status flag
export const ADD_STATUS_FLAG = gql`
  mutation AddStatusFlag($userId: uuid!, $newFlag: String!) {
    update_user_analytics(
      where: { ua_user_id: { _eq: $userId } }
      _append: { ua_status_flags: $newFlag }
    ) {
      returning {
        ua_status_flags
      }
    }
  }
`;

// Optional: update seller thresholds text
export const UPDATE_SELLER_THRESHOLDS = gql`
  mutation UpdateSellerThresholds($userId: uuid!, $thresholds: String!) {
    update_user_analytics(
      where: { ua_user_id: { _eq: $userId } }
      _set: { ua_annual_sales_thresholds: $thresholds }
    ) {
      returning {
        ua_annual_sales_thresholds
      }
    }
  }
`;

export const GET_USER_EMAIL_STATUS = gql`
  query GetUserEmailStatus($userId: uuid!) {
    user(where: { u_id: { _eq: $userId } }) {
      u_id
      u_email_enabled
    }
  }
`;

export const GET_HEAR_ABOUT_US_BREAKDOWN = gql`
  query GetHearAboutUsBreakdown {
    user(where: { u_hear_about_us: { _is_null: false } }) {
      u_hear_about_us
    }
  }
`;

export const RESTORE_USER_PAYOUTS = gql`
  mutation RestoreUserPayouts($userId: uuid!) {
    update_user(
      where: { u_id: { _eq: $userId } }
      _set: {
        u_payouts_voided: false
        u_void_reason: null
        u_void_date: null
      }
    ) {
      returning {
        u_id
        u_payouts_voided
        u_void_reason
        u_void_date
      }
    }
    update_ticket_placement(
      where: {
        ticket: { u_id: { _eq: $userId } }
        tp_status: { _eq: Sold }
        tp_payout_status: { _eq: Voided_Payout }
        tp_is_support_vanderbilt_nil_fund: { _eq: false }
        tp_deleted_at: { _is_null: true }
        _or: [
          { tp_payment_status: { _is_null: true } }
          { tp_payment_status: { _eq: Failed } }
        ]
      }
      _set: { tp_payout_status: Unvoided_Payout }
    ) {
      affected_rows
    }
  }
`;

export const VOID_USER_PAYOUTS = gql`
  mutation VoidUserPayouts($userId: uuid!, $reason: String, $date: timestamptz) {
    update_user(
      where: { u_id: { _eq: $userId } }
      _set: {
        u_payouts_voided: true
        u_void_reason: $reason
        u_void_date: $date
      }
    ) {
      returning {
        u_id
        u_payouts_voided
        u_void_reason
        u_void_date
      }
    }
    update_ticket_placement(
      where: {
        ticket: { u_id: { _eq: $userId } }
        tp_status: { _eq: Sold }
        tp_payout_status: { _eq: Unvoided_Payout }
        tp_is_support_vanderbilt_nil_fund: { _eq: false }
        tp_deleted_at: { _is_null: true }
        _or: [
          { tp_payment_status: { _is_null: true } }
          { tp_payment_status: { _eq: Failed } }
          { tp_payment_status: { _eq: Inprogress } }
        ]
      }
      _set: { tp_payout_status: Voided_Payout }
    ) {
      affected_rows
    }
  }
`;

// ========== Team Management Queries and Mutations ==========

export const GET_ALL_LEAGUE_CATEGORIES = gql`
  query GetAllLeagueCategories {
league_categories(where: { lc_id: { _eq: $lc_id } }) {      lc_id
      lc_abbrev
      lc_name
      lc_colour_code
      lc_brand_name
    }
  }
`;


export const ADD_USER_PREFERENCE_TEAM = gql`
  mutation AddUserPreferenceTeam($userId: uuid!, $teamId: uuid!) {
    insert_user_preference_one(
      object: { u_id: $userId, lc_id: $teamId }
    ) {
      id
      u_id
      lc_id
    }
  }
`;

export const REMOVE_USER_PREFERENCE_TEAM = gql`
  mutation RemoveUserPreferenceTeam($userId: uuid!, $teamId: uuid!) {
    delete_user_preference(
      where: { _and: [{ u_id: { _eq: $userId } }, { lc_id: { _eq: $teamId } }] }
    ) {
      affected_rows
    }
  }
`;

// Get user teams with league category details
export const GET_USER_TEAMS_WITH_SOLD_STATUS = gql`
  query GetUserTeamsWithSoldStatus($userId: uuid!) {
    user_preference(where: { u_id: { _eq: $userId } }) {
      lc_id
      league_category {
        lc_id
        lc_abbrev
        lc_name
        lc_colour_code
      }
    }
  }
`;
export const GET_AVAILABLE_TEAMS_FOR_USER = gql`
  query GetAvailableTeamsForUser($limit: Int = 3000) {
    league_categories(
      where: {
        lc_deleted_at: { _is_null: true }
        lc_abbrev: { _is_null: false }
        lc_is_active: { _eq: true }
      }
      limit: $limit
      order_by: { lc_name: asc }
    ) {
      lc_id  
      lc_abbrev 
      lc_name 
      lc_colour_code  
      lc_brand_name 
      l_id
    }
  }
`;

// Mutation to validate and remove team (with sold ticket check)
export const REMOVE_USER_TEAM_WITH_VALIDATION = gql`
  mutation RemoveUserTeamWithValidation($userId: uuid!, $teamId: uuid!) {
    delete_user_preference(
      where: { _and: [{ u_id: { _eq: $userId } }, { lc_id: { _eq: $teamId } }] }
    ) {
      affected_rows
    }
  }
`;



// Mutation for admin to remove a user's team preference (with built-in validation)
export const ADMIN_REMOVE_USER_PREFERENCE_TEAM = gql`
  mutation AdminRemoveUserPreferenceTeam($userId: uuid!, $teamId: uuid!) {
    delete_user_preference(
      where: { _and: [{ u_id: { _eq: $userId } }, { lc_id: { _eq: $teamId } }] }
    ) {
      affected_rows
    }
  }
`;